import { globals, page as pageIndex } from '../../globals'
import {
  matchParameters,
  filterRegions,
  returnDateFormat,
  sortFieldList,
  mapGroupNotesOptionsValues,
  returnTextValuesForClearedFilters,
  mapGroupNotesFieldList } from './helpers'
import {
  START_DATA_FETCH,
  DATA_FETCHED,
  FETCH_FAILED,
  SAVE_GROUP_NOTES_OPTIONS,
  RETURN_DEFAULT_REPORT,
  OPEN_SAVED_REPORT,
  getFormDataHandlers,
  actionGroupNoteHandler } from './getFormData'
import { UPDATE_DATA, actionHandler } from './updateData'
import { CLEAR_FILTERS, NEW_REPORT_SAVED } from './reportLine'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_REGULATION_START = 'CREATE_REGULATION_START'
export const CREATE_REGULATION_SUCCESS = 'CREATE_REGULATION_SUCCESS'
export const CREATE_REGULATION_FAIL = 'CREATE_REGULATION_FAIL'
export const CLEAR_REGULATION = 'CLEAR_REGULATION'
export const GET_REGULATION_START = 'GET_REGULATION_START'
export const GET_REGULATION_SUCCESS = 'GET_REGULATION_SUCCESS'
export const GET_REGULATION_FAIL = 'GET_REGULATION_FAIL'
export const UPDATE_REGULATION_START = 'UPDATE_REGULATION_START'
export const UPDATE_REGULATION_SUCCESS = 'UPDATE_REGULATION_SUCCESS'
export const UPDATE_REGULATION_FAIL = 'UPDATE_REGULATION_FAIL'
// ------------------------------------
// Actions
// ------------------------------------
export const returnDefaultRegulation = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_REGULATION })
  }
}

export const setNewRegulation = (regulation) => {
  return (dispatch) => {
    dispatch({ type: CREATE_REGULATION_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(regulation),
    }
    fetch(`${globals.apiUrl}/api/regulation`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: CREATE_REGULATION_SUCCESS,
          payload: { json },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: CREATE_REGULATION_FAIL })
    })
  }
}

export const getRegulation = (regulationId) => {
  return (dispatch) => {
    dispatch({ type: GET_REGULATION_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'GET',
      credentials: 'include',
      headers,
    }
    fetch(`${globals.apiUrl}/api/regulation/${regulationId}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_REGULATION_SUCCESS,
          payload: {
            json,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_REGULATION_FAIL })
    })
  }
}

export const updateRegulation = (regulationId, regulation) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_REGULATION_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'PUT',
      credentials: 'include',
      headers,
      body: JSON.stringify(regulation),
    }
    fetch(`${globals.apiUrl}/api/regulation/${regulationId}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: UPDATE_REGULATION_SUCCESS,
          payload: {
            json,
          },
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: UPDATE_REGULATION_FAIL })
    })
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [START_DATA_FETCH] : getFormDataHandlers['START_DATA_FETCH'],
  [FETCH_FAILED] : getFormDataHandlers['FETCH_FAILED'],
  [DATA_FETCHED] : (state, action) => {
    const { page, field } = action.location
    const { json } = action.payload
    const mappedApiData = mapGroupNotesFieldList(json.FieldList)
    if (page !== pageIndex.regs) {
      return state
    }
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        [page]: {
          ...state.renderData[page],
          [field]: {
            fieldList: sortFieldList(json.FieldList),
            fieldOptions: mapGroupNotesOptionsValues(json.FieldOptions),
            regionList: filterRegions(json.RegionList),
            subjectList: json.SubjectList,
            favoritesList: json.FavoritesList,
            archiveStartYear: json.ArchiveStartYear,
            clientId: json.ClientId,
            userId: json.UserId,
            regulationTypes: json.RegulationTypes,
            defaultReport: json.DefaultReport
          }
        }
      },
      formDataValue: {
        ...state.formDataValue,
        [page]: {
          ...state.formDataValue[page],
          [field]: {
            ...state.formDataValue[page][field],
            radio: {
              ...state.formDataValue[page][field].radio,
              ...mappedApiData.radio
            },
            dateTime: {
              ...state.formDataValue[page][field].dateTime,
              ...mappedApiData.dateTime
            },
            textValues: {
              ...state.formDataValue[page][field].textValues,
              ...mappedApiData.textValues
            }
          }
        }
      }
    }
  },
  [SAVE_GROUP_NOTES_OPTIONS] : (state, action) => action.location.page !== pageIndex.regs
    ? state : actionGroupNoteHandler(state, action),
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.regs ? state : actionHandler(state, action),
  [CREATE_REGULATION_START] : (state) => {
    return {
      ...state,
      isFetchingData: false,
    }
  },
  [CREATE_REGULATION_SUCCESS] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      regulationId: json,
    }
  },
  [CREATE_REGULATION_FAIL] : (state) => {
    return {
      ...state,
      isFetchingData: false,
    }
  },
  [CLEAR_FILTERS] : (state, action) => {
    const { page } = action
    if (page !== pageIndex.regs) {
      return state
    }
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        [page]: {
          ...clearState.formDataValue[page],
          groupNotes: {
            ...clearState.formDataValue[page].groupNotes,
            textValues: returnTextValuesForClearedFilters
          }
        }
      }
    }
  },
  [RETURN_DEFAULT_REPORT] : (state, action) => {
    const { page } = action
    if (page !== pageIndex.regs) {
      return {
        ...state
      }
    }
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        [page]: {
          ...initialState.formDataValue[page],
          groupNotesOptions: {
            selected: [
              ...state.formDataValue[page].groupNotesOptions.selected,
            ],
            radio: {
              sw0h: false,
            }
          }
        }
      },
      renderData: {
        ...state.renderData,
      }
    }
  },
  [OPEN_SAVED_REPORT] : (state, action) => {
    const { page } = action
    const { json } = action.payload
    if (page !== pageIndex.regs || json === undefined) {
      return {
        ...state,
      }
    } else {
      const criteria = matchParameters(json.ReportCriteria, state.renderData[page].groupNotes.fieldList)
      let favorites = criteria.filters.personalreport ? criteria.filters.personalreport : []
      favorites = criteria.filters.notinpersonalreport ? [...favorites, 'notinpersonalreport'] : favorites
      return {
        ...state,
        isFetchingData: false,
        formDataValue: {
          ...state.formDataValue,
          [page]: {
            ...initialState.formDataValue[page],
            defaultSearch: {
              ...initialState.formDataValue[page].defaultSearch,
              title: json.Name,
              textValues: {
                ...initialState.formDataValue[page].defaultSearch.textValues,
                reporttitle: criteria.filters.reporttitle || '',
                citation: criteria.filters.citation || ''
              },
              radio: {
                reporttype: criteria.filters.reporttype[0] || 'alltracked',
              },
              dateTime: {
                recorddatestart: criteria.filters.recorddatestart
                  ? returnDateFormat(criteria.filters.recorddatestart[0])
                  : new Date(new Date().getFullYear(), 0, 1),
                recorddateend: criteria.filters.recorddateend
                  ? returnDateFormat(criteria.filters.recorddateend[0]) : new Date(),
                commentsdatestart: criteria.filters.commentsdatestart
                  ? returnDateFormat(criteria.filters.commentsdatestart[0]) : ' ',
                commentsdateend: criteria.filters.commentsdateend
                  ? returnDateFormat(criteria.filters.commentsdateend[0]) : ' ',
              }
            },
            viewingOptions: {
              selected: criteria.viewingOptions.selected || [],
              radio: {
                histlist: criteria.viewingOptions.historyRadioButton
                  ? criteria.viewingOptions.historyRadioButton
                  : 'History By line',
                howmany: criteria.viewingOptions.howmany ? criteria.viewingOptions.howmany : '25',
              },
            },
            groupNotes: {
              selected: criteria.groupNotesFilters ? criteria.groupNotesFilters.selected : [],
              radio: {
                noteslogic: criteria.filters.noteslogic === 'and' || criteria.filters.noteslogic === undefined
                  ? 'ALL selected Group Notes criteria must be true.'
                  : 'ANY selected Group Notes criteria must be true.'
              },
              dateTime: {
                noteslastupdatestart: criteria.filters.noteslastupdatestart
                  ? returnDateFormat(criteria.filters.noteslastupdatestart[0]) : ' ',
                noteslastupdateend: criteria.filters.noteslastupdateend
                  ? returnDateFormat(criteria.filters.noteslastupdateend[0]) : ' ',
              },
              textValues: criteria.groupNotesFilters.textValues
            },
            groupNotesOptions: {
              selected: criteria.groupNotesOptions ? criteria.groupNotesOptions : [],
              radio: {
                sw0h: false,
              }
            },
            additionalFilters: {
              textValues: {
                title: criteria.filters.title ? criteria.filters.title : '',
                summary: criteria.filters.summary ? criteria.filters.summary : '',
                history: criteria.filters.history ? criteria.filters.history : '',
                personalnotes: criteria.filters.personalnotes ? criteria.filters.personalnotes : '',
              },
              dateTime: {
                hearingdatestart: criteria.filters.hearingdatestart
                  ? returnDateFormat(criteria.filters.hearingdatestart[0]) : ' ',
                hearingdateend: criteria.filters.hearingdateend
                  ? returnDateFormat(criteria.filters.hearingdateend[0]) : ' ',
                actiondatestart: criteria.filters.actiondatestart
                  ? returnDateFormat(criteria.filters.actiondatestart[0]) : ' ',
                actiondateend: criteria.filters.actiondateend
                  ? returnDateFormat(criteria.filters.actiondateend[0]) : ' ',
                personalnotesstart: criteria.filters.personalnotesstart
                  ? returnDateFormat(criteria.filters.personalnotesstart[0]) : ' ',
                personalnotesend: criteria.filters.personalnotesend
                  ? returnDateFormat(criteria.filters.personalnotesend[0]) : ' ',
              }
            },
            advancedEditingTools: {
              selected: criteria.advancedEditingTools.selected || [],
              radio: {
                sortheader: !!criteria.advancedEditingTools.sortheader,
                sort1: criteria.advancedEditingTools.sort1[0],
                sort2: criteria.advancedEditingTools.sort2[0],
                sort3: criteria.advancedEditingTools.sort3[0],
                sort4: criteria.advancedEditingTools.sort4[0],
              }
            },
            reportFormat: {
              selected: criteria.mapOptions.selectedAdvancedOptions
                ? [criteria.mapOptions.selectedAdvancedOptions] : [],
              radio: {
                mapit: !!criteria.mapOptions.mapit,
                outformat: criteria.mapOptions.outformat,
              }
            },
            regType: {
              selected: criteria.filters.regtype ? criteria.filters.regtype : [],
            },
            recordCreator: {
              selected: criteria.filters.regcreator ? criteria.filters.regcreator : [],
            },
            archivedYear: {
              selected: criteria.filters.archive ? criteria.filters.archive : ['current'],
            },
            archivedSubjects: {
              selected: criteria.filters.archivedsubjects ? criteria.filters.archivedsubjects : [],
            },
            subjects: {
              selected: criteria.filters.subjects ? criteria.filters.subjects : []
            },
            favorites: {
              selected: favorites,
            },
            states: {
              selected: criteria.filters.states ? criteria.filters.states : []
            },
            progress: {
              selected: criteria.filters.progress ? criteria.filters.progress : [],
            },
            maps: {
              selected: criteria.mapOptions.selected !== undefined ? criteria.mapOptions.selected : [],
              textValues: {
                lowcountcolor: criteria.mapOptions.lowcountcolor ||
                state.formDataValue[page].maps.textValues.lowcountcolor,
                medcountcolor: criteria.mapOptions.medcountcolor ||
                state.formDataValue[page].maps.textValues.medcountcolor,
                highcountcolor: criteria.mapOptions.highcountcolor ||
                state.formDataValue[page].maps.textValues.highcountcolor,
                foundbillscolor: criteria.mapOptions.foundbillscolor ||
                state.formDataValue[page].maps.textValues.foundbillscolor,
              },
            },
          }
        },
        renderData: {
          ...state.renderData,
          [page]: {
            ...state.renderData[page],
            groupNotes: {
              ...state.renderData[page].groupNotes,
              selectedReport: json,
            }
          }
        }
      }
    }
  },
  [NEW_REPORT_SAVED] : (state, action) => {
    const { json, name } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        R: {
          ...state.renderData.R,
          saveReportId: json,
        }
      },
      formDataValue: {
        ...state.formDataValue,
        R: {
          ...state.formDataValue.R,
          defaultSearch: {
            ...state.formDataValue.R.defaultSearch,
            title: name,
          }
        }
      }
    }
  },
  [CLEAR_REGULATION] : (state) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
      },
      formDataValue: {
        ...state.formDataValue,
        R: {
          ...state.formDataValue.R,
          ARgroupNotes: {},
          ARgroupNotesOptions:{
            selected: [],
            radio: {
              sw0h: false,
            }
          },
          ARregulationTitle: {
            textValues: {
              reporttitle: '',
            }
          },
          ARstates: {
            selected: [],
            radio: {
              r0r: '',
            },
          },
          ARregulationType: {
            radio: {
              sr1t: '',
            }
          },
          ARprogress: {
            radio: {
              sr2p: '',
            },
          },
          ARcitationNumber: {
            textValues: {
              ti1r: '',
            }
          },
          ARofficialContact: {
            textValues: {
              ti2r: '',
            }
          },
          ARsummary: {
            textValues: {
              ti3r: '',
            }
          },
          ARsubject: {
            selected: [],
          },
          ARhistory: {
            radio: {},
            dateTime: {},
            textValues: {},
          },
          ARupload: {
            radio: {},
            dateTime: {},
            textValues: {
              iff0: '',
              ifs0: '',
              source0: '',
            }
          },
          ARlink: {
            radio: {},
            dateTime: {},
            textValues: {},
          },
          ARrows: {
            ARhistory: [
              {
                key: 0,
                type: 'ARhistory',
              },
            ],
            ARupload: [
              {
                key: 0,
                type: 'ARupload',
              },
            ],
            ARlink: [
              {
                key: 0,
                type: 'ARlink',
              },
            ],
          },
        }
      }
    }
  },
  [GET_REGULATION_SUCCESS] : (state, action) => {
    const { json } = action.payload
    const regObject = json.SelectedRegulation
    const localStore = JSON.parse(localStorage.getItem('formData'))
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        R: {
          ...state.renderData.R,
          selectedRegulation: regObject,
        }
      },
      formDataValue: {
        ...state.formDataValue,
        R: {
          ...state.formDataValue.R,
          ARregulationTitle: {
            textValues: {
              ti0r: regObject.Title ? regObject.Title : '',
            }
          },
          ARstates: {
            selected: [],
            radio: {
              r0r: regObject.RegionCode !== null
                ? localStore.regionList.filter(item => item.RegionCode === regObject.RegionCode)[0].Name
                : '',
            },
          },
          ARregulationType: {
            radio: {
              sr1t: regObject.RegulationTypeId !== null ? `${regObject.RegulationTypeId}` : '',
            }
          },
          ARprogress: {
            radio: {
              sr2p: '',
            },
          },
          ARcitationNumber: {
            textValues: {
              ti1r: regObject.Citation !== null ? regObject.Citation : '',
            }
          },
          ARofficialContact: {
            textValues: {
              ti2r: regObject.OfficialContact !== null ? regObject.OfficialContact : '',
            }
          },
          ARsummary: {
            textValues: {
              ti3r: regObject.Summary !== null ? regObject.Summary : '',
            }
          },
          ARsubject: {
            selected: [],
          },
          ARhistory: {
            radio: {},
            dateTime: {},
            textValues: {},
          },
          ARupload: {
            radio: {},
            dateTime: {},
            textValues: {
              iff0: '',
              ifs0: '',
              source0: '',
            }
          },
          ARlink: {
            radio: {},
            dateTime: {},
            textValues: {},
          },
          ARrows: {
            ARhistory: [
              {
                key: 0,
                type: 'ARhistory',
              },
            ],
            ARupload: [
              {
                key: 0,
                type: 'ARupload',
              },
            ],
            ARlink: [
              {
                key: 0,
                type: 'ARlink',
              },
            ],
          },
        }
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
const clearState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {
    R: {
      groupNotes: {},
    },
  },
  formDataValue: {
    R: {
      ARgroupNotes: {},
      ARgroupNotesOptions:{
        selected: [],
        radio: {
          sw0h: false,
        }
      },
      ARregulationTitle: {
        textValues: {
          ti0r: '',
        }
      },
      ARstates: {
        selected: [],
        radio: {
          r0r: '',
        },
      },
      ARregulationType: {
        radio: {
          sr1t: '',
        }
      },
      ARprogress: {
        radio: {
          sr2p: '',
        },
      },
      ARcitationNumber: {
        textValues: {
          ti1r: '',
        }
      },
      ARofficialContact: {
        textValues: {
          ti2r: '',
        }
      },
      ARsummary: {
        textValues: {
          ti3r: '',
        }
      },
      ARsubject: {
        selected: [],
      },
      ARhistory: {
        radio: {},
        dateTime: {},
        textValues: {},
      },
      ARupload: {
        radio: {},
        dateTime: {},
        textValues: {
          iff0: '',
          ifs0: '',
          source0: '',
        }
      },
      ARlink: {
        radio: {},
        dateTime: {},
        textValues: {},
      },
      ARrows: {
        ARhistory: [
          {
            key: 0,
            type: 'ARhistory',
          },
        ],
        ARupload: [
          {
            key: 0,
            type: 'ARupload',
          },
        ],
        ARlink: [
          {
            key: 0,
            type: 'ARlink',
          },
        ],
      },
      viewingOptions: {
        selected: [],
        radio: {
          histlist: '',
          howmany: '25',
        },
      },
      defaultSearch : {
        title: 'Default Search',
        textValues: {
          reporttitle: '',
          citation: '',
        },
        radio: {
          reporttype: 'alltracked',
        },
        dateTime: {
          recorddatefrom: new Date(new Date().getFullYear(), 0, 1),
          recorddateend: new Date(),
          commentsdatestart: ' ',
          commentsdateend: ' ',
        }
      },
      groupNotes: {
        selected: [],
        radio: {
          noteslogic: 'ALL selected Group Notes criteria must be true.',
        },
        dateTime: {
          noteslastupdatestart: ' ',
          noteslastupdateend: ' ',
        },
        textValues: {},
      },
      groupNotesOptions: {
        selected: [],
        radio: {
          sw0h: false,
        }
      },
      additionalFilters: {
        textValues: {
          title: '',
          summary: '',
          history: '',
          personalnotes: '',
        },
        dateTime: {
          hearingdatestart: ' ',
          hearingdateend: ' ',
          actiondatestart: ' ',
          actiondateend: ' ',
          personalnotesstart: ' ',
          personalnotesend: ' ',
        }
      },
      advancedEditingTools: {
        selected: [],
        radio: {
          sortheader: false,
          sort1: 'state',
          sort2: 'title',
          sort3: 'citation',
          sort4: 'progressnum',
        }
      },
      reportFormat: {
        selected: [],
        radio: {
          mapit: false,
          outformat: 'html',
        }
      },
      regType: {
        selected: [],
      },
      recordCreator: {
        selected: [],
      },
      archivedYear: {
        selected: ['current'],
      },
      archivedSubjects: {
        selected: [],
      },
      subjects: {
        selected: [],
      },
      favorites: {
        selected: [],
      },
      states: {
        selected: [],
      },
      progress: {
        selected: [],
      },
      priority: {
        selected: [],
      },
      position: {
        selected: [],
      },
      revenue: {
        selected: [],
      },
      compliance: {
        selected: [],
      },
      department: {
        selected: [],
      },
      maps: {
        selected: [],
        textValues: {
          lowcountcolor: '#9cc1e6',
          medcountcolor: '#4175b2',
          highcountcolor: '#243e66',
          foundbillscolor: '#4175b2',
        },
      },
    },
  },
}
const initialState = {
  isFetchingData: true,
  errorCode: '',
  renderData: {
    R: {
      groupNotes: {},
    },
  },
  formDataValue: {
    R: {
      ARgroupNotes: {},
      ARgroupNotesOptions:{
        selected: [],
        radio: {
          sw0h: false,
        }
      },
      ARregulationTitle: {
        textValues: {
          ti0r: '',
        }
      },
      ARstates: {
        selected: [],
        radio: {
          r0r: '',
        },
      },
      ARregulationType: {
        radio: {
          sr1t: '',
        }
      },
      ARprogress: {
        radio: {
          sr2p: '',
        },
      },
      ARcitationNumber: {
        textValues: {
          ti1r: '',
        }
      },
      ARofficialContact: {
        textValues: {
          ti2r: '',
        }
      },
      ARsummary: {
        textValues: {
          ti3r: '',
        }
      },
      ARsubject: {
        selected: [],
      },
      ARhistory: {
        radio: {},
        dateTime: {},
        textValues: {},
      },
      ARupload: {
        radio: {},
        dateTime: {},
        textValues: {
          iff0: '',
          ifs0: '',
          source0: '',
        }
      },
      ARlink: {
        radio: {},
        dateTime: {},
        textValues: {},
      },
      ARrows: {
        ARhistory: [
          {
            key: 0,
            type: 'ARhistory',
          },
        ],
        ARupload: [
          {
            key: 0,
            type: 'ARupload',
          },
        ],
        ARlink: [
          {
            key: 0,
            type: 'ARlink',
          },
        ],
      },
      viewingOptions: {
        selected: [
          'viewsearchcriteria', 'viewcreator', 'viewcitation',
          'viewemailalerts', 'viewemailit', 'viewcontact',
          'viewdoctype', 'viewprogress', 'viewotherlinks',
          'viewkeydates', 'viewsubject', 'viewsummary',
          'viewhistory', 'viewremarks', 'viewfutureaction',
          'viewpersonalnotes', 'viewpersreports'
        ],
        radio: {
          histlist: 'History by Line',
          howmany: '25',
        },
      },
      defaultSearch : {
        title: 'Default Search',
        textValues: {
          reporttitle: 'Regulatory Report',
          citation: '',
        },
        radio: {
          reporttype: 'alltracked',
        },
        dateTime: {
          recorddatestart: new Date(new Date().getFullYear(), 0, 1),
          recorddateend: new Date(),
          commentsdatestart: ' ',
          commentsdateend: ' ',
        }
      },
      groupNotes: {
        selected: [],
        radio: {
          noteslogic: 'ALL selected Group Notes criteria must be true.',
        },
        dateTime: {
          noteslastupdatestart: ' ',
          noteslastupdateend: ' ',
        },
      },
      groupNotesOptions: {
        selected: ['editnotes', 'viewnoteslastupdated'],
        radio: {
          sw0h: false,
        }
      },
      additionalFilters: {
        textValues: {
          title: '',
          summary: '',
          history: '',
          personalnotes: '',
        },
        dateTime: {
          hearingdatestart: ' ',
          hearingdateend: ' ',
          actiondatestart: ' ',
          actiondateend: ' ',
          personalnotesstart: ' ',
          personalnotesend: ' ',
        }
      },
      advancedEditingTools: {
        selected: [],
        radio: {
          sortheader: false,
          sort1: 'state',
          sort2: 'title',
          sort3: 'citation',
          sort4: 'progressnum',
        }
      },
      reportFormat: {
        selected: [],
        radio: {
          mapit: false,
          outformat: 'html',
        }
      },
      regType: {
        selected: [],
      },
      recordCreator: {
        selected: [],
      },
      archivedYear: {
        selected: ['current'],
      },
      archivedSubjects: {
        selected: [],
      },
      subjects: {
        selected: [],
      },
      favorites: {
        selected: [],
      },
      states: {
        selected: [],
      },
      progress: {
        selected: [],
      },
      priority: {
        selected: [],
      },
      position: {
        selected: [],
      },
      revenue: {
        selected: [],
      },
      compliance: {
        selected: [],
      },
      department: {
        selected: [],
      },
      maps: {
        selected: [],
        textValues: {
          lowcountcolor: '#9cc1e6',
          medcountcolor: '#4175b2',
          highcountcolor: '#243e66',
          foundbillscolor: '#4175b2',
        },
      },
    },
    Bill: {
      favorites: {
        selected: [],
      },
    },
  },
}
export default function regsDataReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/regsFormData.js